import React from 'react';
import { default as Button } from 'shared/buttons/AddButton';

const AddButton = ({ onAdd, disabled }) => <Button onClick={onAdd} disabled={disabled} />;

export default AddButton;
